module.exports = __webpack_public_path__ + "static/sharp-5608c8d84c016359c6c62d82ff3f83ae.jpg";